// Function to colorize JSON for display
export function colorizeJson(json) {
  // If no JSON, return empty
  if (!json) return null

  // Replace with syntax highlighting
  const highlighted = json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
    (match) => {
      let cls = "text-purple-600" // Default for numbers

      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = "text-red-600" // Keys
        } else {
          cls = "text-green-600" // Strings
        }
      } else if (/true|false/.test(match)) {
        cls = "text-blue-600" // Booleans
      } else if (/null/.test(match)) {
        cls = "text-gray-600" // null
      }

      return `<span class="${cls}">${match}</span>`
    },
  )

  // Replace brackets and braces with colored versions
  const withBrackets = highlighted
    .replace(/\{/g, '<span class="text-yellow-600">{</span>')
    .replace(/\}/g, '<span class="text-yellow-600">}</span>')
    .replace(/\[/g, '<span class="text-yellow-600">[</span>')
    .replace(/\]/g, '<span class="text-yellow-600">]</span>')
    .replace(/,/g, '<span class="text-gray-600">,</span>')

  return <div dangerouslySetInnerHTML={{ __html: withBrackets }} />
}
